import styled from 'styled-components';
import { default as C } from '@assets/themes/colors';

interface IStyleProps {
  active?: boolean;
  bodyHeight?: number;
};

interface IButtonProps {
  selected: boolean;
};

export const Root = styled.div`
  display: flex;
  flex-direction: row;
  font-family: Roboto;
  align-items: center;
`;

export const GeneralRow = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Row1 = styled.div`
  display: flex;
  height: 48px;
  flex-grow: 0;
  margin-bottom: 7px;
  align-items: center;
`;

export const Row2 = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 5px;
`;

export const Link = styled.div`
  font-family: Roboto;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #ee3434;
  cursor: pointer;
  margin-left: auto;
  margin-bottom: 5px;
`;

export const Button = styled.div`
  width: 256px;
  height: 48px;
  border: ${(props: IButtonProps) => (props.selected ? "solid 1px #204078" : "solid 1px rgba(0, 0, 0, 0.2)")};
  background-color: ${(props: IButtonProps) => (props.selected ? "#eef0f5" : "var(--white)")};
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  display: flex;
  align-items: center;
  cursor: pointer;
  &:hover {
    border: solid 1px #204078;
  }
`;

export const Title = styled.span`
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #8d8d8d;
  margin-left: 15.8px;
  flex-grow: 2;
`;

export const Others = styled.div`
  display: flex;
  align-items: center;
  margin-left: 23px;
  margin-bottom: 30px;
`;

export const Message = styled.span`
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  margin-right: 17px;
  margin-left: 3px;
  color: #c4c4c4;
  white-space: nowrap;
`;
